var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"policy text-center d-flex align-center justify-center"},[_c('v-container',[_c('div',{staticClass:"policy__wrapper text-start",domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }